import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'reactstrap';
import InputText from '../../../../components/FormFields/InputText';
import * as yup from 'yup';
import SelectList from '../../../../components/select/SelectList';
import Textarea from '../../../../components/FormFields/Textarea';
import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import {
  addFinding,
  getAllInvolvedUsers,
  getAllResponsibleUsersData,
} from '../../../../services/findings';
import {Link, useHistory, useParams} from 'react-router-dom';
import BackBtn from '../../../RiskComponents/pageHeader/img/arrow-left.svg';
import {FINDING_STATUS, RISK_LEVEL} from '../../const';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import {format} from 'date-fns';
import roles from "../../../../utils/roles";

const AddFindingsForm = () => {
  const lang = getLanguage();
  const history = useHistory();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [usersInvolvedOptions, setUsersInvolvedOptions] = useState([])
  const [userResponsibleIdOptions, setUserResponsibleIdOptions] = useState([])
  const [disableUsersInvolved, setDisableUsersInvolved] = useState(true);
  const [departmentIDs,setDepartmentIDs] = useState([]);


  const [schema, setSchema] = useState(
    yup.object().shape({
      department: yup.array().required(t('message.fieldRequired')).nullable(),
      usersInvolved: yup.array().nullable(),
      userResponsibleId: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
      initialDeadline: yup.date().required(t('message.fieldRequired')).nullable(),
      hdRequestId: yup
          .string()
          .trim(),
      findingName: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(150, `${t('message.max', {max: 150})}`),
      finding: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      recommendation: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      managementResponse: yup
        .string()
        .required(t('message.fieldRequired'))
        .trim()
        .min(3, `${t('message.min', {min: 3})}`)
        .max(20000, `${t('message.max', {max: 20000})}`),
      riskLevel: yup.object().required(t('message.fieldRequired')).nullable(),
      findingStatus: yup
        .object()
        .required(t('message.fieldRequired'))
        .nullable(),
    })
  );
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const {handleSubmit, watch, errors, setValue} = methods;

  const submitForm = async (data) => {
    setIsLoading(true);
    const formatIssueAtDate =
      format(new Date(data.initialDeadline), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.initialDeadline), 'hh:mm:ss');

    const payload = {
      name: data?.findingName,
      departments: data?.department?.map(r=> ({ id: r?.value})),
      responsiblePerson: {
        id: data?.userResponsibleId?.value,
      },
      usersInvolved: data?.usersInvolved?.map(r=> ({ id: r?.value})),
      revision: {
        id: params?.id,
      },
      riskLevel: data?.riskLevel?.value,
      findingStatus: data?.findingStatus?.value,
      proposedActions: data?.recommendation,
      managementResponse: data?.managementResponse,
      initialDeadline: formatIssueAtDate,
      content: data?.finding,
      hdRequestId: data?.hdRequestId
    };
    try {
      const response = await addFinding(payload);
      if (response.status === 201) {
        Toast.fire({
          title: t('departments.message.addSuccess', {
            entity: t('common.revision'),
          }),
          icon: 'success',
        });
      }
      history.push(`/revisions/${params?.id}/findings`);
    } catch (err) {
      if (err.response.data.code === 'finding-exist') {
        Swal.fire({
          text: t('message.findingExists'),
          icon: 'error',
        });
      } else if (
        err.response.data.code === 'missing-responsible-users-in-department'
      ) {
        Swal.fire({
          text: t('revisions.noResponsibleUser'),
          icon: 'error',
        });
      } else if (err.response.data.code === 'finding-invalid-deadline-date') {
        Swal.fire({
          text: t('revisions.findingInvalidDeadlineDate'),
          icon: 'error',
        });
      } else {
        Swal.fire({
          text: t('common.deleteFailed3', {
            entity: t('common.revision'),
          }),
          icon: 'error',
        });
      }
    }
    setIsLoading(false);
  };

const watchUserResponsible = watch('userResponsibleId');
const watchUsersInvolved = watch('usersInvolved');
  const watchDepartment = watch('department');

  const fetchAllUsersInvolved = async () => {
    let selectedDepartmentIds=watchDepartment?.map((d) => {
      return d.value
    })
  try {
    const {data} = await getAllInvolvedUsers(watchUserResponsible['value'], selectedDepartmentIds);
    return data;
  } catch (e) {

  }
};
const fetchAllUsersResponsibleData = async (departmentIds) => {
  try {
    const {data} = await getAllResponsibleUsersData(departmentIds);
    return data;
  } catch (e) {}
};

useEffect(() => {
  if (watchUserResponsible?.value && watchDepartment) {
    setDisableUsersInvolved(false)
    fetchAllUsersInvolved().then((r) => {
      let usersInvolvedOptions = [];
      r.forEach((item) => {
        usersInvolvedOptions.push(
          {value: item.id, label: item?.fullName}
        );
      });
      setUsersInvolvedOptions(usersInvolvedOptions);
    });
  }
}, [watchUserResponsible, watchDepartment,watchUsersInvolved]);
//
useEffect(() => {
  let selectedDepartmentIds=watchDepartment?.map((d) => {
    return d.value
  })
    fetchAllUsersResponsibleData(selectedDepartmentIds).then((r) => {
      setDepartmentIDs(selectedDepartmentIds)
      let userResponsibleIdOptions = [];
      r.map((item) => {
        userResponsibleIdOptions.push(
          {value: item.id, label: item?.fullName,authorities:item.authorities}
        );
      });
      setUserResponsibleIdOptions(userResponsibleIdOptions);
    });
}, [watchUsersInvolved,watchDepartment,watchUserResponsible]);

useEffect(()=>{
  let selectedDepartmentSectorDirectors=watchDepartment?.map((d) => {
    return d.sectorDirectorId
  })
  if(selectedDepartmentSectorDirectors && !selectedDepartmentSectorDirectors.includes(watchUserResponsible?.value)){
    if (watchUserResponsible && watchUserResponsible.authorities?.includes(roles.role_sector_director)){
      setValue('userResponsibleId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }
  if (watchDepartment === null) {
    setDisableUsersInvolved(true)
    setValue('usersInvolved', '', {
      shouldValidate: false,
      shouldDirty: false,
    });
    setValue('userResponsibleId', '', {
      shouldValidate: false,
      shouldDirty: false,
    });
  }
},[watchDepartment])
  useEffect(()=>{
    if (watchUserResponsible && watchUsersInvolved) {
      let newUsersInvolved=watchUsersInvolved.filter((item) => item?.value!==watchUserResponsible?.value)
      setValue('usersInvolved', newUsersInvolved, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  },[watchUserResponsible])

  return (
    <div>
      <div className="container-fluid controls d-flex align-items-center justify-content-end">
        <Link
          to={window.location.pathname}
          className="return-btn-revisions d-flex "
          onClick={() => history.go(-1)}
        >
          <img src={BackBtn} alt="icon" />
          <span>{t('buttons.addFinding')}</span>
        </Link>
        <div className="row">
          <div className="col-12 d-flex justify-content-end"></div>
        </div>
      </div>

      <div>
        <FormProvider {...methods}>
          <form
            id={'myForm'}
            onSubmit={handleSubmit(submitForm)}
            className={'addFindingForm'}
          >
            <Row className="mb-2">
              <Col className="col-6 col-xl-3">
                <label className="label-referentId">
                  {t('revisions.findingName')}
                </label>
                <InputText
                  type="string"
                  name="findingName"
                  className="form-control input-field"
                  placeholder={t('revisions.placeholder.findingName')}
                  id="referenceId"
                />
                <label className="label-referentId">
                  {t('revisions.findingContent')}
                </label>
                <Textarea
                  type="string"
                  name="finding"
                  className="form-control input-field"
                  placeholder={t('revisions.placeholder.findingContent')}
                  id="finding"
                />
                <label className="label-referentId">
                  {t('revisions.recommendation')}
                </label>
                <Textarea
                  type="string"
                  name="recommendation"
                  className="form-control input-field"
                  placeholder={t('revisions.placeholder.recommendation')}
                  id="finding"
                />
                <label className="label-referentId">
                  {t('revisions.managementResponse')}
                </label>
                <Textarea
                  type="string"
                  name="managementResponse"
                  className="form-control input-field"
                  placeholder={t('revisions.placeholder.managementResponse')}
                  id="managementResponse"
                />
              </Col>
              <Col>
                <label className="">{t('departments.department')}</label>
                <SelectInfinite
                  api="/departments"
                  name="department"
                  isMulti={true}
                  isDepartmentSelect={true}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="department"
                  placeholder={t('placeholder.departments')}
                />
                <label className='label-measures'>
                  {t('mitigation-measures.IDHDRequest')}
                </label>
                <span className="optional register">
                    {t('common.optional')}
                  </span>
                <InputText
                    type='string'
                    name='hdRequestId'
                    className='form-control input-field'
                    placeholder={t('placeholder.IDHDRequest')}
                    id='hdRequestId'
                />
                <label className="">
                  {t('incurred-risk.placeholder.responsibleUser')}
                </label>
                <SelectInfinite
                    api={`/users/audit-responsible?paged=true&size=20&sort=firstName&sort.sorted=true&departmentId.in=${departmentIDs?.length > 0 ? departmentIDs : ''}`}
                    name="userResponsibleId"
                    labelKey="fullName"
                    placeholder={t('incurred-risk.placeholder.responsibleUser')}
                    className="select"
                    queryKeys={'fullName.contains'}
                />
                {/*<SelectList*/}
                {/*  name="userResponsibleId"*/}
                {/*  className={errors.userResponsibleIdValidation && "error-field"}*/}
                {/*  placeholder={t('incurred-risk.placeholder.responsibleUser')}*/}
                {/*  options={userResponsibleIdOptions}*/}
                {/*/>*/}
                <label className="">{t('revisions.participants')}</label>
                {/*<SelectList*/}
                {/*  isMulti={true}*/}
                {/*  name="usersInvolved"*/}
                {/*  className={errors.usersInvolvedValidation && "error-field"}*/}
                {/*  placeholder={t('revisions.placeholder.participants')}*/}
                {/*  options={usersInvolvedOptions}*/}
                {/*  isDisabled={disableUsersInvolved}*/}
                {/*/>*/}
                <SelectInfinite
                    api={`/users/audit-responsible??page=1&size=20&paged=true&sort=firstName&id.notEquals=${watchUserResponsible ? watchUserResponsible['value'] : ''}&departmentId.in=${departmentIDs?.length > 0 ? departmentIDs : ''}`}
                    name="usersInvolved"
                    labelKey="fullName"
                    placeholder={t('revisions.placeholder.participants')}
                    className="select"
                    queryKeys={'fullName.contains'}
                    isMulti={true}
                    isDisabled={disableUsersInvolved}
                />
                <label className="">{t('revisions.date')}</label>
                <InputDate
                  name="initialDeadline"
                  className="form-control input-field dateInput"
                  // minDate={new Date()}
                />
                <label className="">{t('revisions.riskLevel')}</label>
                <SelectList
                  name="riskLevel"
                  className="select"
                  placeholder={t('revisions.placeholder.riskLevel')}
                  options={
                    getLanguage() === 'eng'
                      ? [
                          {
                            label: RISK_LEVEL.LOW.en,
                            value: RISK_LEVEL.LOW.value,
                          },
                          {
                            label: RISK_LEVEL.MEDIUM.en,
                            value: RISK_LEVEL.MEDIUM.value,
                          },
                        {
                          label: RISK_LEVEL.MODERATE.en,
                          value: RISK_LEVEL.MODERATE.value,
                        },
                          {
                            label: RISK_LEVEL.HIGH.en,
                            value: RISK_LEVEL.HIGH.value,
                          },
                          {
                            label: RISK_LEVEL.NOT_DEFINED.en,
                            value: RISK_LEVEL.NOT_DEFINED.value,
                          }
                        ]
                      : [
                          {
                            label: RISK_LEVEL.LOW.mne,
                            value: RISK_LEVEL.LOW.value,
                          },
                          {
                            label: RISK_LEVEL.MEDIUM.mne,
                            value: RISK_LEVEL.MEDIUM.value,
                          },
                        {
                          label: RISK_LEVEL.MODERATE.mne,
                          value: RISK_LEVEL.MODERATE.value,
                        },
                          {
                            label: RISK_LEVEL.HIGH.mne,
                            value: RISK_LEVEL.HIGH.value,
                          },
                          {
                            label: RISK_LEVEL.NOT_DEFINED.mne,
                            value: RISK_LEVEL.NOT_DEFINED.value,
                          }
                        ]
                  }
                  isClearable
                />
                <label className="">{t('revisions.findingStatus')}</label>
                <SelectList
                  name="findingStatus"
                  className="select"
                  defaultValue= {{
                    label: getLanguage() === 'eng' ? FINDING_STATUS.INCOMPLETE.en : FINDING_STATUS.INCOMPLETE.mne,
                    value: FINDING_STATUS.INCOMPLETE.value,
                  }}
                  placeholder={t('revisions.placeholder.findingStatus')}
                  options={
                    getLanguage() === 'eng'
                      ? [
                          {
                            label: FINDING_STATUS.COMPLETED.en,
                            value: FINDING_STATUS.COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.INCOMPLETE.en,
                            value: FINDING_STATUS.INCOMPLETE.value,
                          },
                          {
                            label: FINDING_STATUS.PARTIALLY_COMPLETED.en,
                            value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.CONTINUOUS.en,
                            value: FINDING_STATUS.CONTINUOUS.value,
                          },
                          {
                            label: FINDING_STATUS.IN_PROGRESS.en,
                            value: FINDING_STATUS.IN_PROGRESS.value,
                          },
                          {
                            label: FINDING_STATUS.ABORTED.en,
                            value: FINDING_STATUS.ABORTED.value,
                          },
                        ]
                      : [
                          {
                            label: FINDING_STATUS.COMPLETED.mne,
                            value: FINDING_STATUS.COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.INCOMPLETE.mne,
                            value: FINDING_STATUS.INCOMPLETE.value,
                          },
                          {
                            label: FINDING_STATUS.PARTIALLY_COMPLETED.mne,
                            value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                          },
                          {
                            label: FINDING_STATUS.CONTINUOUS.mne,
                            value: FINDING_STATUS.CONTINUOUS.value,
                          },
                          {
                            label: FINDING_STATUS.IN_PROGRESS.mne,
                            value: FINDING_STATUS.IN_PROGRESS.value,
                          },
                          {
                            label: FINDING_STATUS.ABORTED.mne,
                            value: FINDING_STATUS.ABORTED.value,
                          },
                        ]
                  }
                  isClearable
                />
              </Col>
              <Col>{/*EMPTY COL FOR LAYOUT*/}</Col>
            </Row>
          </form>

          <div className="container-fluid mt-4 footer">
            <div className="row">
              <div className="col-12 pt-4 pb-4 d-flex justify-content-end footer">
                <button
                  className="secondary-btn"
                  onClick={(event) => {
                    event.preventDefault();
                    history.go(-1);
                  }}
                >
                  {t('common.cancel')}
                </button>
                <button
                  disabled={isLoading}
                  type="submit"
                  form={'myForm'}
                  className="primary-btn"
                >
                  {t('common.save')}
                </button>
              </div>
            </div>
          </div>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddFindingsForm;
